import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import { Close } from '@material-ui/icons';
import Stack from "../Sidebar/TagSidebar/Tags";
import { tags } from "config/recipe-template";
import "./FilterButton.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSvgIcon-root": {
        fontSize:15,
        height: 17,
        opacity: 0.50,
      }
  },
  paper: {
    "& .MuiPopover-paper": {
      top: "88px !important",
      bottom: 0,
      left: "0px !important",
      right: "0px !important",
      zIndex: 2,
      padding: "32px 32px 16px",
      borderRadius: "16px 16px 0 0",
      background: "#fff",
      boxShadow: "0 16px 32px rgb(98 164 219 / 56%)",
      overflow: "scroll",
      maxWidth: "100% !important"
    }
  }
}));

export default function FilterButtonContainer({ api }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [active, setActive] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <> 
      <div className="react-offcanvasButton">
        <div 
          aria-describedby={id} 
          onClick={(e) => {
            handleClick(e);
            setActive(!active)
          }}
          className="react-FilterBtnContainer"
        >
          <div className="react-RecipeBtnText" onClick={handleClick}>
            {active ? "Show Results": "Show Filters"}
          </div>
        </div>
      </div>
      
      <Popover
        className={classes.paper}
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >

        <div className="react-offcanvasClose" 
          onClick={() => {
            setActive(false);
            setAnchorEl(false);
          }}
        >
          <Close className={classes.root}/>
        </div>

        <Stack 
          category="role"
          tags = {tags.role} 
          api = {api}
        />
        <Stack 
            category="industry"
            tags = {tags.industry} 
            api = {api}
        />
        <Stack 
            category="platforms"
            tags = {tags.platforms} 
            api = {api}
        />    

        <Stack 
            category="usecases"
            tags = {tags.usecases} 
            api = {api}
        /> 
      </Popover>
    </>
  );
}